import { EVENTS } from 'src/constants/webSocketConsts/events';
import {
  upsertArticlesToState,
  removeArticlesFromState,
  refreshArticles,
} from 'src/store/knowledgeBase/actions';

const ArticleHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
    case EVENTS.MODIFY:
      return upsertArticlesToState(items);
    case EVENTS.REMOVE: {
      return removeArticlesFromState(items);
    }
    case EVENTS.REFRESH: {
      return refreshArticles(items);
    }
    default:
      break;
  }
  return null;
};

export default ArticleHandler;
